import "./../styles.scss";

import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { notification, Pagination, Select } from "antd";
import { Delete, EditIcon } from "components/icons";
import { Field, Form, Formik } from "formik";
import { compact, debounce, uniqBy } from "lodash";
import React, { useEffect, useMemo, useRef, useState } from "react";
import Modal from "react-modal";
import { useOutletContext } from "react-router-dom";
import { convertIsoDateToStandardFormat } from "utils/date";

import AccessControl from "../../../components/common/AccessControl/accessControl";
import ManageAccess from "../../../components/common/ManageAccess/manageAccess";
import DeleteModal from "../../../components/common/Modals/component";
import CloseModal from "../../../components/icons/CloseModal";
import amplitude from "../../../externals/amplitude";
import { addTeamValidation, editTeamValidation } from "../../../utils/validations";
const { Option } = Select;

const AddTeam = (props) => {
  const firstRef = useRef(true);

  const {
    loder,
    setSearch,
    setCount,
    count,
    search,
    getAllCategory,
    getCreateTeams,
    getAllTeams,
    deleteTeamById,
    editTeamById,
    getAllTagsById,
    id,
    selectedCategories,
    getEntityTypes,
    ENTITY_TYPE,
  } = props;

  const { clientSetting } = useOutletContext();

  const [limit, setLimit] = useState(20);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [event, setEvent] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [delmodalOpen, setDeleteModalOpen] = useState(false);
  const [playersData, setPlayersData] = useState([]);
  const [teamLoder, setTeamLoder] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [allCategory, setAllCategory] = useState([]);
  const [teams, setTeams] = useState([]);
  const [editData, setEditData] = useState("");
  const [initialState, setInitialState] = useState({
    event: "",
    teamName: "",
    players: [],
  });

  const initialEditState = useMemo(() => {
    return {
      teamName: editData?.name,
      players: editData?.playerIds,
    };
  }, [editData]);

  const delOpen = (id) => {
    setDeleteId(id);
    setDeleteModalOpen(true);
  };

  const delclose = () => {
    setDeleteModalOpen(false);
  };
  const handlePageChange = (current) => {
    setActivePage(current);
  };
  useEffect(() => {
    if (event) {
      getTeamFun(event);
    }
  }, [activePage, event]);

  const disallowRosterMutation = useMemo(() => {
    return clientSetting?.permissions?.disableRosterMutation;
  }, [clientSetting?.permissions?.disableRosterMutation]);

  const openEdit = (data) => {
    setIsEdit(true);
    setPlayersData(compact(uniqBy([...playersData, ...(data.players || [])], "_id")));
    setEditData(data);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const editClose = () => {
    setIsEdit(false);
  };

  //handle input search
  const onChangeSearch = async (e) => {
    setActivePage(1);
    setSearch(e.target.value);
    setCount(count + 1);
  };

  useEffect(() => {
    if (firstRef.current) {
      getTeamFun(event);
      firstRef.current = false;
    } else {
      const timer = setTimeout(() => {
        getTeamFun(event);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [search]);

  const getTeamFun = async () => {
    setEvent(event);
    const categoryId = await allCategory?.filter((data) => data.name == event);
    if (categoryId.length > 0) {
      const { value } = await getAllTeams({
        category: categoryId[0]?.name,
        search: search,
        entityId: id,
        pageNo: activePage,
        limit,
      });
      if (value.success) {
        setTeams(value);
      }
    }
  };

  const deleteTeamModel = async () => {
    setTeamLoder(true);
    const { value } = await deleteTeamById({
      _id: deleteId?._id,
      entityId: id,
    });
    if (value.success) {
      notification["success"]({ message: value.message });
    } else {
      notification["error"]({ message: value.message });
    }
    setTeamLoder(false);
    // handlePageChange(1);
    // setSearch('')
    getTeamFun();
    delclose();
    amplitude.logEvent("team_deleted", { team_id: deleteId?._id });
  };

  const getPlayersData = async (search) => {
    const payload = {
      category: event,
      tagType: "player",
      search,
      entityId: id,
    };
    const value = await getAllTagsById(payload);
    if (value.value.success) {
      setPlayersData(value.value.tag);
    }
  };

  const openModal = async () => {
    setInitialState({ ...initialState, event: event });
    setFieldEvent(event);
    setIsOpen(true);
    amplitude.logEvent("add_team_clicked");
  };
  const handleSubmit = async ({ event, teamName, players }) => {
    const categoryId = allCategory && allCategory.filter((data) => data.name == event);
    const { value } = await getCreateTeams({
      playerIds: players,
      name: teamName,
      category: categoryId[0]?.name,
      entityId: id,
    });
    if (value?.success) {
      notification["success"]({ message: value.message });
    } else {
      notification["error"]({ message: value.message });
    }
    setActivePage(1);
    getTeamFun();
    closeModal();
    amplitude.logEvent("team_added", { sport: event, team: teamName, players: players });
  };
  const handleSubmitEdit = async ({ players, teamName }) => {
    const categoryId = allCategory && allCategory.filter((data) => data.name == event);
    const { value } = await editTeamById({
      playerIds: players,
      name: teamName,
      category: categoryId[0]?.name,
      entityId: id,
      _id: editData?._id,
    });
    if (value.success) {
      notification["success"]({ message: value.message });
    } else {
      notification["error"]({ message: value.message });
    }
    getTeamFun();
    editClose();
    amplitude.logEvent("team_edited", { team_id: editData?._id, team: teamName, players: players });
  };

  const setFieldEvent = async (event) => {
    const categoryId = (await allCategory) && allCategory?.filter((data) => data.name == event);
    if (categoryId && categoryId.length > 0) {
      const payload = {
        category: categoryId[0]?.name,
        tagType: "player",
        search,
        entityId: id,
      };
      const data = await getAllTagsById(payload);
      if (data.value.success) {
        setPlayersData(data.value.tag);
      }
    }
  };
  //GET ALL CATEGORYS
  const getAllCategorys = async () => {
    if (id) {
      const { value } = await getAllCategory({
        entityId: id,
      });
      if (value?.success) {
        let assignCategories = value?.data?.filter((data) => selectedCategories?.includes(data?.name));

        setAllCategory(assignCategories);
      }
    }
  };
  useEffect(() => {
    if (selectedCategories) getAllCategorys();
  }, [selectedCategories]);

  const handleSelectCategory = (e) => {
    setActivePage(1);
  };

  useEffect(() => {
    setEvent(allCategory[0]?.name);
  }, [allCategory]);

  useEffect(() => {
    if (event) {
      getPlayersData();
    }
  }, [event]);

  const debouncedSearchPlayers = debounce(getPlayersData, 500);
  return (
    <>
      <DeleteModal
        deleteComanModel={deleteTeamModel}
        loder={teamLoder}
        modalIsOpen={delmodalOpen}
        setDeleteModalOpen={setDeleteModalOpen}
        header="Delete"
        content="Are you sure you want to delete?"
      />
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <div className="modal-content">
          <AccessControl code="add_team" page="organization-profile">
            <div className="react-modal-header">
              <h5 className="react-modal-title">Add Team</h5>
              <button type="button" onClick={closeModal} className="btn btn__default">
                <CloseModal />
              </button>
            </div>
          </AccessControl>
          <Formik initialValues={initialState} validationSchema={addTeamValidation} onSubmit={handleSubmit}>
            {({ errors, touched, setFieldValue, values }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="form-group">
                      <label className="form-label">
                        Categorys <span className="required">*</span>
                      </label>
                      <div className="form-pop-trigger-block">
                        <Field
                          className="custom-ant-select"
                          name="event"
                          showSearch
                          // onChange={(value) => setFieldValue("event", value)}
                          onChange={(value) => {
                            setFieldEvent(value);
                            setFieldValue("event", value);
                          }}
                          component={Select}
                          dropdownStyle={{ zIndex: 99999999 }}
                          // placeholder="Select Sport"
                          defaultValue={event || "Select Category"}
                        >
                          {allCategory.length &&
                            allCategory.map((data, index) => {
                              return (
                                <>
                                  <Option key={data?._id} value={data.name}>
                                    {data?.displayName}
                                  </Option>
                                </>
                              );
                            })}
                        </Field>
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Team Name <span className="required">*</span>
                      </label>
                      <Field className="form-control" name="teamName" type="text" placeholder="Enter Team Name" />
                      {touched.teamName && errors.teamName && <div className="invalid-feedback">{errors.teamName}</div>}
                    </div>
                    <div className="field-items">
                      <label className="form-label">
                        Players <span className="required">*</span>
                      </label>
                      <div className="form-pop-trigger-block">
                        <Select
                          mode="multiple"
                          showSearch
                          placeholder="Select Players"
                          optionFilterProp="children"
                          className="custom-ant-select"
                          value={values?.players}
                          name="players"
                          onChange={(value) => setFieldValue("players", value)}
                          onSearch={(search) => debouncedSearchPlayers(search)}
                          onBlur={() => {
                            getPlayersData();
                          }}
                        >
                          {playersData &&
                            playersData.length > 0 &&
                            playersData.map((data, index) => {
                              return (
                                <Option key={index} value={data.id}>
                                  {data.name}
                                </Option>
                              );
                            })}
                        </Select>
                        {touched.players && errors.players && <div className="invalid-feedback">{errors.players}</div>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="react-modal-footer">
                  <div className="react-foo-container">
                    <div className="right-btn-block text-center">
                      <button type="button" className="btn btn-white" onClick={closeModal}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Add
                        {loder == false ? (
                          ""
                        ) : (
                          <Spin
                            size="large"
                            indicator={<LoadingOutlined style={{ fontSize: 50, color: "#000", marginLeft: 50 }} spin />}
                            className="loader__full"
                          ></Spin>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
      <Modal
        isOpen={isEdit}
        onRequestClose={editClose}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <Formik initialValues={initialEditState} validationSchema={editTeamValidation} onSubmit={handleSubmitEdit}>
          {({ errors, touched, setFieldValue, values }) => (
            <Form>
              <div className="modal-content">
                <div className="react-modal-header">
                  <h5 className="react-modal-title">Edit Team</h5>
                  <button type="button" onClick={editClose} className="btn btn__default">
                    <CloseModal />
                  </button>
                </div>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="form-group">
                      <label className="form-label">
                        Team Name <span className="required">*</span>
                      </label>
                      <Field
                        disabled={disallowRosterMutation}
                        className="form-control"
                        name="teamName"
                        type="text"
                        placeholder="Enter Display Name"
                      />
                      {touched.teamName && errors.teamName && <div className="invalid-feedback">{errors.teamName}</div>}
                    </div>
                    <div className="field-items">
                      <label className="form-label">
                        Players <span className="required">*</span>
                      </label>
                      <div className="form-pop-trigger-block">
                        <Select
                          mode="multiple"
                          showSearch
                          placeholder="Tournament"
                          optionFilterProp="children"
                          className="custom-ant-select"
                          value={values?.players}
                          name="players"
                          onChange={(value) => setFieldValue("players", value)}
                          onSearch={(search) => debouncedSearchPlayers(search)}
                          onBlur={() => {
                            getPlayersData();
                          }}
                        >
                          {playersData &&
                            playersData.length > 0 &&
                            playersData.map((data, index) => {
                              return (
                                <Option key={index} value={data.id}>
                                  {data.name}
                                </Option>
                              );
                            })}
                        </Select>
                        {touched.players && errors.players && <div className="invalid-feedback">{errors.players}</div>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="react-modal-footer">
                  <div className="react-foo-container">
                    <div className="right-btn-block text-center">
                      <button type="button" className="btn btn-white" onClick={editClose}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Add
                        {loder == false ? (
                          ""
                        ) : (
                          <Spin
                            size="large"
                            indicator={<LoadingOutlined style={{ fontSize: 50, color: "#000", marginLeft: 50 }} spin />}
                            className="loader__full"
                          ></Spin>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>

      <div className="col-md-12">
        <div className="border-block groups-block">
          <div className="left-block">
            <h4 className="title-sm-t">Team</h4>
            <p>Entertainment, Sports, News</p>
          </div>
          <AccessControl code="add_team" page="organization-profile">
            <ManageAccess value={getEntityTypes(id) !== ENTITY_TYPE.WORKSPACES}>
              <div className="right-btn-block">
                <div class="button-container">
                  {/* <button class="btn btn-white me-3" onClick={openCSVModal}>
                  Upload a CSV file
                </button> */}
                  <button disabled={disallowRosterMutation} class="btn btn-primary" onClick={openModal}>
                    Add Team
                  </button>
                </div>
              </div>
            </ManageAccess>
          </AccessControl>
        </div>
        <br />
        <div className="form-pop-trigger-block">
          <div className="form-group">
            <label className="form-label"> Select Category </label>
            <Select
              showSearch
              className="custom-ant-select"
              value={event}
              placeholder="Select Sport"
              onChange={(e) => {
                setEvent(e);
                handleSelectCategory(e);
              }}
            >
              {allCategory.length &&
                allCategory.map((data, index) => {
                  return (
                    <>
                      <Option key={index} value={data.name}>
                        {data?.displayName}
                      </Option>
                    </>
                  );
                })}
            </Select>
          </div>
        </div>
        <div className="configuration-items-row mt-5 row">
          <div className="row mb-4 justify-content-end">
            <div className="col-md-6">
              <h5 className="title-small mb-0">Added Teams</h5>
            </div>
            <div className="col-md-6">
              <div className="page-toolbar-styled-item">
                <input
                  type="text"
                  value={search}
                  onChange={(e) => onChangeSearch(e)}
                  placeholder="Search Teams"
                  className="form-control filters-search-control"
                />
              </div>
            </div>
          </div>
          {teams &&
            teams?.teams?.map((data) => {
              return (
                <>
                  <div className="col-md-2">
                    <div className="confi-block-col-container configuration-column flex-column gap-0 p-2">
                      <div className="confi-block-col">
                        <h4 className="word-break-common">
                          {data?.name
                            ?.split(" ")
                            .map((letter, index) => letter.charAt(0).toUpperCase() + letter.slice(1).toLowerCase())
                            .join(" ")}
                        </h4>
                        <h6>{convertIsoDateToStandardFormat(data?.createdAt)}</h6>
                      </div>
                      <div className="action-buttons">
                        <AccessControl code="edit_team" page="organization-profile">
                          <ManageAccess value={getEntityTypes(id) !== ENTITY_TYPE.WORKSPACES}>
                            <button>
                              <EditIcon
                                onClick={() => {
                                  openEdit(data);
                                }}
                              />
                            </button>
                          </ManageAccess>
                        </AccessControl>
                        <AccessControl code="delete_team" page="organization-profile">
                          <ManageAccess value={getEntityTypes(id) !== ENTITY_TYPE.WORKSPACES}>
                            <button disabled={disallowRosterMutation}>
                              <Delete
                                onClick={() => {
                                  delOpen(data);
                                }}
                              />
                            </button>
                          </ManageAccess>
                        </AccessControl>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
        </div>
        <ManageAccess value={!teams?.teams?.length > 0}>
          <div className="col-md-12">
            <div className="w-100 text-center py-5">
              <h4>No Data Found!</h4>
            </div>
          </div>
        </ManageAccess>
        <Pagination
          showSizeChanger={false}
          current={activePage}
          pageSize={limit}
          onChange={handlePageChange}
          total={teams?.totalCount}
          className="text-center mt-3"
        />
      </div>
    </>
  );
};
export default AddTeam;
